import { TEST_ENVIRONMENT } from './constants';
import countries from './countries';
import { getEnvironment } from './index';

function getBaseUrl(countryShortName) {
  const environment = getEnvironment();
  if (environment === TEST_ENVIRONMENT) return 'test';

  const country = countries.find(c => c.shortName === countryShortName);
  return country[environment];
}

export default getBaseUrl;
